class AdpModalController {
  constructor() {
    this.name = 'adpModal';
  }
  close() {
    this.show = false;
  }
}

export default AdpModalController;



// WEBPACK FOOTER //
// ./src/app/components/adpModal/adpModal.controller.js